export const PermissionSubChannel = {
    PUT: "mgr-sub_channel-**-PUT",
    POST: "mgr-sub_channel-POST",
    DELETE: "mgr-sub_channel-**-DELETE",
    GET: "mgr-sub_channel-search-GET",
    GET_UUID: "mgr-sub_channel-**-GET"
};